module.exports = __webpack_public_path__ + "img/64-white.6e21871a.svg";